import {useState} from 'react'
import PropTypes from 'prop-types'

import Logos from './Logos'
import {conversionRatePartnerShape} from './conversionRate'

import ActiveState from './ActiveState'
import NullState from './NullState'
import OtherState from './OtherState'

const FormComponent = ({
  partner,
  isValid,
  isSubmitting,
  onSubmit,
  onCancel,
  memberStatus,
  memberBusinessName,
  abn,
  onShowTermsModal,
}) => {
  const [agreed, setAgreed] = useState(false)

  const toggleAgreed = () => setAgreed(!agreed)

  const connectDisabled = !isValid || isSubmitting || !agreed

  return (
    <>
      <Logos />
      {memberStatus === 'active' && (
        <ActiveState
          partner={partner}
          memberBusinessName={memberBusinessName}
          abn={abn}
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onCancel}
          onShowTermsModal={onShowTermsModal}
          agreed={agreed}
          toggleAgreed={toggleAgreed}
          connectDisabled={connectDisabled}
        />
      )}
      {memberStatus === null && (
        <NullState
          partner={partner}
          isValid={isValid}
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
          onCancel={onCancel}
          onShowTermsModal={onShowTermsModal}
          agreed={agreed}
          toggleAgreed={toggleAgreed}
          connectDisabled={connectDisabled}
        />
      )}
      {memberStatus !== null && memberStatus !== 'active' && (
        <OtherState
          memberStatus={memberStatus}
          memberBusinessName={memberBusinessName}
          abn={abn}
        />
      )}
    </>
  )
}

FormComponent.propTypes = {
  partner: conversionRatePartnerShape,
  memberStatus: PropTypes.string,
  memberBusinessName: PropTypes.string,
  abn: PropTypes.string.isRequired,
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onShowTermsModal: PropTypes.func.isRequired,
}

FormComponent.defaultProps = {
  partner: null,
  memberStatus: null,
  memberBusinessName: null,
}

export default FormComponent
